import { convertNeSwToNwSe } from "google-map-react"
import React, { useContext } from "react"
import { StateContext } from "../../StateProvider"

const ChoseButton = ({ id }) => {
  const [state, setState] = useContext(StateContext)
  const handleSingleButton = () => {
    let newArray = [...state]
    newArray[id] = { ...newArray[id], state: !newArray[id].state }
    setState([...newArray])
  }


  return (
    <button className="main-btn" onClick={handleSingleButton}>
      {state[id].state ? "Ausgewählt" : "Auswählen"}
    </button>
  )
}

export default ChoseButton
